import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($rootScope, $scope, $uibModal, $timeout, utilsService, loggerService, tracking, jsSdkBooking, jsSdkUser, imgix) {
  $scope.fadeIn = false;
  $scope.loading = false;

  $scope.$watch('booking', booking => {
    if (booking && booking.venue) {
      $scope.tax = $scope.booking.taxPercent;
      $scope.tip = ($scope.booking.tipPercent * 100).toFixed(0);
      $scope.fadeIn = true;
    }
  });

  $scope.profileImg = function() {
    const user = jsSdkUser.getCurrentUser();
    const defaultImage = 'https://assets.tablelist.com/www/assets/default_profile.png';

    return (user && user.imageUrl) ? user.imageUrl : defaultImage;
  };

  $scope.imgix = function(src) {
    const options = {
      width: 50,
      height: 50
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.showRedeemCode = false;
  $scope.errorMsg = '';

  $scope.isLoggedIn = function() {
    return $rootScope.isLoggedIn();
  };

  $scope.addDiscount = function(form) {
    $scope.submittedCode = true;
    $scope.errorMsg = '';

    if (!$scope.promoCode || $scope.promoCode === '') {
      return;
    }

    const options = {
      promoCode: $scope.promoCode
    };

    $scope.loading = true;

    jsSdkBooking.addBookingDiscount($scope.booking.id, options).then(function(response) {
      _success(response);

      $scope.successMsg = 'Promo applied!';

      form.$setPristine();

      tracking.trackEvent(SEGMENT_EVENTS.RedeemedPromoCode, {
        code: $scope.promoCode
      });
    }, response => {
      _error(response);

      form.$setPristine();
    });
  };

  $scope.removeDiscount = function(discountId) {
    const message = 'Would you like to remove this discount?';

    if (!confirm(message)) return; //eslint-disable-line

    const options = {
      bookingDiscountId: discountId
    };

    $scope.loading = true;

    jsSdkBooking.removeBookingDiscount($scope.booking.id, options).then(_success, _error);

    $scope.successMsg = null;
  };

  function _success(booking) {
    const promise = jsSdkBooking.readById(booking.id);

    promise.then(b => {
      $scope.loading = false;
      $scope.booking = b;
      $scope.submittedCode = false;
      $scope.errorMsg = '';
      $scope.promoCode = null;
    }, resp => {
      _error(resp);
    });
  }

  function _error(response) {
    loggerService.error(response);
    $scope.submittedCode = false;
    $scope.successMsg = null;
    $scope.errorMsg = response.data.errors[0].message;
    $scope.loading = false;
  }

  $scope.getInventoryName = function(inventoryType, inventoryQuantity) {
    if (!inventoryType || !inventoryQuantity) return null;

    const name = inventoryType.substring(0, 1).toUpperCase() + inventoryType.substring(1, inventoryType.length).toLowerCase();

    return inventoryQuantity > 1 ? (`${name}s`) : name;
  };

  $scope.getBookingDateSentence = function(booking) {
    return utilsService.getBookingDateSentence(booking);
  };
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$uibModal',
  '$timeout',
  'utilsService',
  'loggerService',
  'trackingService',
  'jsSdk.booking',
  'jsSdk.user',
  'jsSdk.imgix'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/checkoutPreview/controller.js